import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./lowerb.css"; // Ensure this file exists


class Lowerb extends Component {
    render() {
      return (
        <section className="project-section">
          <div className="project-content">
            <div className="left-content">
              
              <h1 className="w3-text-dark-grey">Turn your vision into reality—smart cultivations lead to great opportunities.</h1>
            </div>
            <div className="right-content">
             
              <Link to="/contact" className="btn btn-dark text-light py-3 px-5">CONTACT US</Link>
            </div>
          </div>
        </section>
      );
    }
  }
  
  export default Lowerb;